import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_adVF2uRka6 from "/app/node_modules/nuxt-bugsnag/dist/runtime/client/plugin.js";
import motion_jmBwdqbgTJ from "/app/node_modules/@vueuse/motion/dist/nuxt/runtime/templates/motion.js";
import composition_sLxaNGmlSL from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import amplitude_client_a5NDjvTWdZ from "/app/plugins/amplitude.client.ts";
import auto_animate_uTpJuTGsMC from "/app/plugins/auto-animate.ts";
import dragscroll_U3dCpB8oXl from "/app/plugins/dragscroll.ts";
import global_2XP5sjpyNs from "/app/plugins/global.ts";
import scrollbar_client_afVkuO58C3 from "/app/plugins/scrollbar.client.ts";
import toast_client_9z8IIRO0Dx from "/app/plugins/toast.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_adVF2uRka6,
  motion_jmBwdqbgTJ,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  amplitude_client_a5NDjvTWdZ,
  auto_animate_uTpJuTGsMC,
  dragscroll_U3dCpB8oXl,
  global_2XP5sjpyNs,
  scrollbar_client_afVkuO58C3,
  toast_client_9z8IIRO0Dx
]